import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "card border-0 rounded-3 bg-white position-relative z-1 mb-4",
  style: {"padding":"10px"}
}
const _hoisted_2 = {
  class: "row g-2",
  style: {"--bs-gutter-x":"10px"}
}
const _hoisted_3 = { class: "col-md-4" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "col-md-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewBookings = _resolveComponent("NewBookings")!
  const _component_CheckIn = _resolveComponent("CheckIn")!
  const _component_CheckOut = _resolveComponent("CheckOut")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_NewBookings)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_CheckIn)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_CheckOut)
      ])
    ])
  ]))
}